import { t } from 'i18next';
import React from 'react';
import { useState } from 'react';
import { FiZap } from 'react-icons/fi';
import { useSwiper } from 'swiper/react';

const Flashcard = props => {
  const { question, isSubmitting, handleSubmitQuestion, currentQuestion, setCurrentQuestion, questionsLength, setLoopQuestions, update } = props;

  const swiper = useSwiper();
  const [isTurned, setIsTurned] = useState(false);
  const [iDontKnow, setIDontKnow] = useState(false);

  async function handleRight() {
    setIsTurned(!isTurned);
    await handleSubmitQuestion(question, true, true, true);

    if (questionsLength === 1) {
      setLoopQuestions([]);
    } else {
      setLoopQuestions(prev => {
        const newQuestions = prev.filter(q => q.id !== question.id);
        return newQuestions;
      });
    }
  }

  async function handleMissedQuestion() {
    handleNextCard(question, true, false, true);
  }

  async function handleNextCard(question, knowAnswer, acceptedAnswer, answered) {
    if (questionsLength === 0) return;
    setIsTurned(!isTurned);

    await handleSubmitQuestion(question, knowAnswer, acceptedAnswer, answered);

    setCurrentQuestion(prevState => {
      if (prevState + 1 === questionsLength) {
        return 0;
      } else {
        return prevState + 1;
      }
    });

    if (currentQuestion + 1 === questionsLength) {
      update();
      swiper.slideTo(0, 2000);
    } else {
      setTimeout(() => {
        swiper.slideNext(2000);
      }, 500);
    }

    setIDontKnow(false);
  }

  return (
    <div className="flip-wrapper">
      <div className={isTurned ? 'flip flip--turned' : 'flip'}>
        <div className="flip__front">
          <div className="flashcard">
            <div className="flashcard__header">
              <p className="flashcard__count">
                <FiZap /> {question?.position}
              </p>
            </div>

            <div className="flashcard__body">
              <h4 className="flashcard__title">{question?.question}</h4>
            </div>

            <div className="flashcard__footer">
              <button
                className="btn btn--wide btn--outline"
                onClick={() => setIsTurned(!isTurned)}
              >
                {t('flashCard.buttonIKnow')}
              </button>
              <button
                className="btn btn--wide btn--outline"
                onClick={() => {
                  setIsTurned(!isTurned);
                  setIDontKnow(true);
                }}
              >
                {t('flashCard.buttonIDontKnow')}
              </button>
            </div>
          </div>
        </div>

        <div className="flip__back">
          <div className="flashcard flashcard--back">
            <div className="flashcard__header">
              <p className="flashcard__count">
                <FiZap /> {question?.position}
              </p>
            </div>

            <div className="flashcard__body">
              <h4 className="flashcard__title">{isTurned && question?.answer}</h4>
              {!iDontKnow && <p className="flashcard__text">{t('flashCard.basedPreviousAnswer')}</p>}
            </div>

            <div className="flashcard__footer">
              {!iDontKnow ? (
                <>
                  <button
                    disabled={isSubmitting}
                    className="btn btn--wide btn--outline"
                    onClick={handleRight}
                  >
                    {t('flashCard.buttonRight')}
                  </button>
                  <button
                    disabled={isSubmitting}
                    className="btn btn--wide btn--outline"
                    onClick={handleMissedQuestion}
                  >
                    {t('flashCard.buttonWrong')}
                  </button>
                </>
              ) : (
                <button
                  className="btn btn--wide btn--outline"
                  disabled={isSubmitting}
                  onClick={() => handleNextCard(question, false, false, false)}
                >
                  {t('flashCard.buttonNextCard')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flashcard;
